module.exports = __webpack_public_path__ + "static/media/nissan_logo.f756c470.png";